import { render, staticRenderFns } from "./BoxArt3D.vue?vue&type=template&id=664e60b9&"
import script from "./BoxArt3D.vue?vue&type=script&lang=js&"
export * from "./BoxArt3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Node\\megadrive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664e60b9')) {
      api.createRecord('664e60b9', component.options)
    } else {
      api.reload('664e60b9', component.options)
    }
    module.hot.accept("./BoxArt3D.vue?vue&type=template&id=664e60b9&", function () {
      api.rerender('664e60b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BoxArt3D.vue"
export default component.exports